const tbobookingnonlcc = (
	location,
	response,
	invoice,
	dispatch,
	agentInfo,
	fareQuoteEtrav,
	payment,
	FlightBookEtravDispatch,
	history,
	FlightTicketLCCDispatch,
	FlightBookDispatch
) => {
	let formData = {
		TraceId: location.state.IDTBO,
		ResultIndex: location.state.OneflightData.ResultIndex,
		orderId: location.state.orderID,
		paymentId: response === 'success' ? invoice : response.razorpay_payment_id,
		Passengers: location.state.BookingData.map((item) => {
			return {
				Title: item.title,
				FirstName: item.first_name,
				LastName: item.last_name,
				PaxType: item.PaxType,
				DateOfBirth: item.dob,
				Gender: 1,
				// PassportNo: location.state.formData
				// 	? location.state.formData.data.passport
				// 	: '',
				// PassportExpiry: '2023-12-06T00:00:00',
				AddressLine1: 'hello',
				AddressLine2: '',
				Fare: {
					Currency: location.state.OneflightData
						? location.state.OneflightData.Fare.Currency
						: '',
					BaseFare: location.state.OneflightData
						? location.state.OneflightData.Fare.OfferedFare
						: '',
					Tax: location.state.OneflightData
						? location.state.OneflightData.Fare.Tax
						: '',
					YQTax: location.state.OneflightData
						? location.state.OneflightData.Fare.YQTax
						: '',
					AdditionalTxnFeePub: location.state.OneflightData
						? location.state.OneflightData.Fare.AdditionalTxnFeePub
						: '',
					AdditionalTxnFeeOfrd: location.state.OneflightData
						? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
						: '',
					OtherCharges: location.state.OneflightData
						? location.state.OneflightData.Fare.OtherCharges
						: '',
					Discount: location.state.OneflightData
						? location.state.OneflightData.Fare.Discount
						: '',
					PublishedFare: location.state.OneflightData
						? location.state.OneflightData.Fare.PublishedFare
						: '',
					OfferedFare: location.state.OneflightData
						? location.state.OneflightData.Fare.OfferedFare
						: '',
					TdsOnCommission: location.state.OneflightData
						? location.state.OneflightData.Fare.TdsOnCommission
						: '',
					TdsOnPLB: location.state.OneflightData
						? location.state.OneflightData.Fare.TdsOnPLB
						: '',
					TdsOnIncentive: location.state.OneflightData
						? location.state.OneflightData.Fare.TdsOnIncentive
						: '',
					ServiceFee: location.state.OneflightData
						? location.state.OneflightData.Fare.ServiceFee
						: '',
				},
				City: '',
				CountryCode: 'IN',
				CellCountryCode: '+91',
				ContactNo: location.state.formData ? location.state.formData.phone : '',
				Nationality: 'IN',
				Email: location.state.formData ? location.state.formData.email : '',
				IsLeadPax: true,
				FFAirlineCode: null,
				FFNumber: '',
				GSTCompanyAddress: '',
				GSTCompanyContactNumber: '',
				GSTCompanyName: '',
				GSTNumber: '',
				GSTCompanyEmail: '',
			};
		}),
		Baggage: [],
		MealDynamic: [],
		SeatDynamic: [],
	};
	dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
	// {
	// 	// lcc false
	// 	if (location.state.body.AdultCount === 1) {
	// 		let formData = {
	// 			TraceId: location.state.IDTBO,
	// 			ResultIndex: location.state.OneflightData.ResultIndex,
	// 			orderId: location.state.orderID,
	// 			paymentId: response.razorpay_payment_id,
	// 			Passengers: [
	// 				{
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA1
	// 						: '',
	// 					FirstName: location.state.formData
	// 						? location.state.formData.first_nameA1
	// 						: '',
	// 					LastName: location.state.formData
	// 						? location.state.formData.last_nameA1
	// 						: '',
	// 					PaxType: 1,
	// 					DateOfBirth: '1987-12-06T00:00:00',
	// 					Gender: 1,
	// 					// PassportNo: location.state.formData
	// 					// 	? location.state.formData.data.passport
	// 					// 	: '',
	// 					// PassportExpiry: '2023-12-06T00:00:00',
	// 					AddressLine1: location.state.formData
	// 						? location.state.formData.address
	// 						: '',
	// 					AddressLine2: '',
	// 					Fare: {
	// 						Currency: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Currency
	// 							: '',
	// 						BaseFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						Tax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Tax
	// 							: '',
	// 						YQTax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.YQTax
	// 							: '',
	// 						AdditionalTxnFeePub: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeePub
	// 							: '',
	// 						AdditionalTxnFeeOfrd: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
	// 							: '',
	// 						OtherCharges: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OtherCharges
	// 							: '',
	// 						Discount: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Discount
	// 							: '',
	// 						PublishedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.PublishedFare
	// 							: '',
	// 						OfferedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						TdsOnCommission: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnCommission
	// 							: '',
	// 						TdsOnPLB: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnPLB
	// 							: '',
	// 						TdsOnIncentive: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnIncentive
	// 							: '',
	// 						ServiceFee: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.ServiceFee
	// 							: '',
	// 					},
	// 					City: 'Dhanbad',
	// 					CountryCode: 'IN',
	// 					CellCountryCode: '+91',
	// 					ContactNo: location.state.formData
	// 						? location.state.formData.phone
	// 						: '',
	// 					Nationality: 'IN',
	// 					Email: location.state.formData ? location.state.formData.email : '',
	// 					IsLeadPax: true,
	// 					FFAirlineCode: null,
	// 					FFNumber: '',
	// 					GSTCompanyAddress: '',
	// 					GSTCompanyContactNumber: '',
	// 					GSTCompanyName: '',
	// 					GSTNumber: '',
	// 					GSTCompanyEmail: '',
	// 				},
	// 			],
	// 			Baggage: [
	// 				{
	// 					AirlineCode: location.state.OneflightData
	// 						? location.state.OneflightData.AirlineCode
	// 						: '',
	// 					FlightNumber: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Airline.FlightNumber;
	// 								})
	// 						: '',
	// 					WayType: location.state.body ? location.state.body.JourneyType : '',
	// 					Code: 'No Baggage',
	// 					Description: 2,
	// 					Weight: 0,
	// 					Currency: 'INR',
	// 					Price: 5000,
	// 					Origin: location.state.body
	// 						? location.state.body.Segments[0].Origin
	// 						: '',
	// 					Destination: location.state.body
	// 						? location.state.body.Segments[0].Destination
	// 						: '',
	// 				},
	// 			],
	// 			MealDynamic: [
	// 				{
	// 					AirlineCode: location.state.OneflightData
	// 						? location.state.OneflightData.AirlineCode
	// 						: '',
	// 					FlightNumber: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Airline.FlightNumber;
	// 								})
	// 						: '',
	// 					WayType: location.state.body ? location.state.body.JourneyType : '',
	// 					Code: 'No Meal',
	// 					Description: 2,
	// 					AirlineDescription: '',
	// 					Quantity: 1,
	// 					Currency: 'INR',
	// 					Price: 300,
	// 					Origin: location.state.body
	// 						? location.state.body.Segments[0].Origin
	// 						: '',
	// 					Destination: location.state.body
	// 						? location.state.body.Segments[0].Destination
	// 						: '',
	// 				},
	// 			],
	// 			SeatDynamic: [
	// 				{
	// 					AirlineCode: location.state.OneflightData
	// 						? location.state.OneflightData.AirlineCode
	// 						: '',
	// 					FlightNumber: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Airline.FlightNumber;
	// 								})
	// 						: '',
	// 					CraftType: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Craft;
	// 								})
	// 						: '',
	// 					Origin: location.state.body
	// 						? location.state.body.Segments[0].Origin
	// 						: '',
	// 					Destination: location.state.body
	// 						? location.state.body.Segments[0].Destination
	// 						: '',
	// 					AvailablityType: 1,
	// 					Description: 2,
	// 					Code: '2A',
	// 					RowNo: '2',
	// 					SeatNo: 'A',
	// 					SeatType: 1,
	// 					SeatWayType: 2,
	// 					Compartment: 1,
	// 					Deck: 1,
	// 					Currency: 'INR',
	// 					Price: 300,
	// 				},
	// 			],
	// 		};
	// 		dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
	// 	} else if (location.state.body.AdultCount === 2) {
	// 		let formData = {
	// 			TraceId: location.state.IDTBO,
	// 			ResultIndex: location.state.OneflightData.ResultIndex,
	// 			Passengers: [
	// 				{
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA1
	// 						: '',
	// 					FirstName: location.state.formData
	// 						? location.state.formData.first_nameA1
	// 						: '',
	// 					LastName: location.state.formData
	// 						? location.state.formData.last_nameA1
	// 						: '',
	// 					PaxType: 1,
	// 					DateOfBirth: '1987-12-06T00:00:00',
	// 					Gender: 1,
	// 					// PassportNo: location.state.formData
	// 					// 	? location.state.formData.data.passport
	// 					// 	: '',
	// 					// PassportExpiry: '2023-12-06T00:00:00',
	// 					AddressLine1: location.state.formData
	// 						? location.state.formData.address
	// 						: '',
	// 					AddressLine2: '',
	// 					Fare: {
	// 						Currency: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Currency
	// 							: '',
	// 						BaseFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						Tax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Tax
	// 							: '',
	// 						YQTax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.YQTax
	// 							: '',
	// 						AdditionalTxnFeePub: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeePub
	// 							: '',
	// 						AdditionalTxnFeeOfrd: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
	// 							: '',
	// 						OtherCharges: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OtherCharges
	// 							: '',
	// 						Discount: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Discount
	// 							: '',
	// 						PublishedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.PublishedFare
	// 							: '',
	// 						OfferedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						TdsOnCommission: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnCommission
	// 							: '',
	// 						TdsOnPLB: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnPLB
	// 							: '',
	// 						TdsOnIncentive: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnIncentive
	// 							: '',
	// 						ServiceFee: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.ServiceFee
	// 							: '',
	// 					},
	// 					City: 'Dhanbad',
	// 					CountryCode: 'IN',
	// 					CellCountryCode: '+91',
	// 					ContactNo: location.state.formData
	// 						? location.state.formData.phone
	// 						: '',
	// 					Nationality: 'IN',
	// 					Email: location.state.formData ? location.state.formData.email : '',
	// 					IsLeadPax: true,
	// 					FFAirlineCode: null,
	// 					FFNumber: '',
	// 					GSTCompanyAddress: '',
	// 					GSTCompanyContactNumber: '',
	// 					GSTCompanyName: '',
	// 					GSTNumber: '',
	// 					GSTCompanyEmail: '',
	// 				},
	// 				{
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA2
	// 						: '',
	// 					FirstName: location.state.formData
	// 						? location.state.formData.first_nameA2
	// 						: '',
	// 					LastName: location.state.formData
	// 						? location.state.formData.last_nameA2
	// 						: '',
	// 					PaxType: 1,
	// 					DateOfBirth: '1987-12-06T00:00:00',
	// 					Gender: 1,
	// 					// PassportNo: location.state.formData
	// 					// 	? location.state.formData.data.passport
	// 					// 	: '',
	// 					// PassportExpiry: '2023-12-06T00:00:00',
	// 					AddressLine1: location.state.formData
	// 						? location.state.formData.address
	// 						: '',
	// 					AddressLine2: '',
	// 					Fare: {
	// 						Currency: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Currency
	// 							: '',
	// 						BaseFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						Tax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Tax
	// 							: '',
	// 						YQTax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.YQTax
	// 							: '',
	// 						AdditionalTxnFeePub: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeePub
	// 							: '',
	// 						AdditionalTxnFeeOfrd: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
	// 							: '',
	// 						OtherCharges: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OtherCharges
	// 							: '',
	// 						Discount: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Discount
	// 							: '',
	// 						PublishedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.PublishedFare
	// 							: '',
	// 						OfferedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						TdsOnCommission: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnCommission
	// 							: '',
	// 						TdsOnPLB: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnPLB
	// 							: '',
	// 						TdsOnIncentive: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnIncentive
	// 							: '',
	// 						ServiceFee: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.ServiceFee
	// 							: '',
	// 					},
	// 					City: 'Dhanbad',
	// 					CountryCode: 'IN',
	// 					CellCountryCode: '+91',
	// 					ContactNo: location.state.formData
	// 						? location.state.formData.phone
	// 						: '',
	// 					Nationality: 'IN',
	// 					Email: location.state.formData ? location.state.formData.email : '',
	// 					IsLeadPax: true,
	// 					FFAirlineCode: null,
	// 					FFNumber: '',
	// 					GSTCompanyAddress: '',
	// 					GSTCompanyContactNumber: '',
	// 					GSTCompanyName: '',
	// 					GSTNumber: '',
	// 					GSTCompanyEmail: '',
	// 				},
	// 			],
	// 			Baggage: [
	// 				{
	// 					AirlineCode: location.state.OneflightData
	// 						? location.state.OneflightData.AirlineCode
	// 						: '',
	// 					FlightNumber: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Airline.FlightNumber;
	// 								})
	// 						: '',
	// 					WayType: location.state.body ? location.state.body.JourneyType : '',
	// 					Code: 'No Baggage',
	// 					Description: 2,
	// 					Weight: 0,
	// 					Currency: 'INR',
	// 					Price: 5000,
	// 					Origin: location.state.body
	// 						? location.state.body.Segments[0].Origin
	// 						: '',
	// 					Destination: location.state.body
	// 						? location.state.body.Segments[0].Destination
	// 						: '',
	// 				},
	// 			],
	// 			MealDynamic: [
	// 				{
	// 					AirlineCode: location.state.OneflightData
	// 						? location.state.OneflightData.AirlineCode
	// 						: '',
	// 					FlightNumber: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Airline.FlightNumber;
	// 								})
	// 						: '',
	// 					WayType: location.state.body ? location.state.body.JourneyType : '',
	// 					Code: 'No Meal',
	// 					Description: 2,
	// 					AirlineDescription: '',
	// 					Quantity: 1,
	// 					Currency: 'INR',
	// 					Price: 300,
	// 					Origin: location.state.body
	// 						? location.state.body.Segments[0].Origin
	// 						: '',
	// 					Destination: location.state.body
	// 						? location.state.body.Segments[0].Destination
	// 						: '',
	// 				},
	// 			],
	// 			SeatDynamic: [
	// 				{
	// 					AirlineCode: location.state.OneflightData
	// 						? location.state.OneflightData.AirlineCode
	// 						: '',
	// 					FlightNumber: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Airline.FlightNumber;
	// 								})
	// 						: '',
	// 					CraftType: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Craft;
	// 								})
	// 						: '',
	// 					Origin: location.state.body
	// 						? location.state.body.Segments[0].Origin
	// 						: '',
	// 					Destination: location.state.body
	// 						? location.state.body.Segments[0].Destination
	// 						: '',
	// 					AvailablityType: 1,
	// 					Description: 2,
	// 					Code: '2A',
	// 					RowNo: '2',
	// 					SeatNo: 'A',
	// 					SeatType: 1,
	// 					SeatWayType: 2,
	// 					Compartment: 1,
	// 					Deck: 1,
	// 					Currency: 'INR',
	// 					Price: 300,
	// 				},
	// 			],
	// 		};
	// 		dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
	// 	} else if (location.state.body.AdultCount === 3) {
	// 		let formData = {
	// 			TraceId: location.state.IDTBO,
	// 			ResultIndex: location.state.OneflightData.ResultIndex,
	// 			orderId: location.state.orderID,
	// 			paymentId: response.razorpay_payment_id,
	// 			Passengers: [
	// 				{
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA1
	// 						: '',
	// 					FirstName: location.state.formData
	// 						? location.state.formData.first_nameA1
	// 						: '',
	// 					LastName: location.state.formData
	// 						? location.state.formData.last_nameA1
	// 						: '',
	// 					PaxType: 1,
	// 					DateOfBirth: '1987-12-06T00:00:00',
	// 					Gender: 1,
	// 					// PassportNo: location.state.formData
	// 					// 	? location.state.formData.data.passport
	// 					// 	: '',
	// 					// PassportExpiry: '2023-12-06T00:00:00',
	// 					AddressLine1: location.state.formData
	// 						? location.state.formData.address
	// 						: '',
	// 					AddressLine2: '',
	// 					Fare: {
	// 						Currency: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Currency
	// 							: '',
	// 						BaseFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						Tax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Tax
	// 							: '',
	// 						YQTax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.YQTax
	// 							: '',
	// 						AdditionalTxnFeePub: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeePub
	// 							: '',
	// 						AdditionalTxnFeeOfrd: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
	// 							: '',
	// 						OtherCharges: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OtherCharges
	// 							: '',
	// 						Discount: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Discount
	// 							: '',
	// 						PublishedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.PublishedFare
	// 							: '',
	// 						OfferedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						TdsOnCommission: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnCommission
	// 							: '',
	// 						TdsOnPLB: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnPLB
	// 							: '',
	// 						TdsOnIncentive: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnIncentive
	// 							: '',
	// 						ServiceFee: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.ServiceFee
	// 							: '',
	// 					},
	// 					City: 'Dhanbad',
	// 					CountryCode: 'IN',
	// 					CellCountryCode: '+91',
	// 					ContactNo: location.state.formData
	// 						? location.state.formData.phone
	// 						: '',
	// 					Nationality: 'IN',
	// 					Email: location.state.formData ? location.state.formData.email : '',
	// 					IsLeadPax: true,
	// 					FFAirlineCode: null,
	// 					FFNumber: '',
	// 					GSTCompanyAddress: '',
	// 					GSTCompanyContactNumber: '',
	// 					GSTCompanyName: '',
	// 					GSTNumber: '',
	// 					GSTCompanyEmail: '',
	// 				},
	// 				{
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA2
	// 						: '',
	// 					FirstName: location.state.formData
	// 						? location.state.formData.first_nameA2
	// 						: '',
	// 					LastName: location.state.formData
	// 						? location.state.formData.last_nameA2
	// 						: '',
	// 					PaxType: 1,
	// 					DateOfBirth: '1987-12-06T00:00:00',
	// 					Gender: 1,
	// 					// PassportNo: location.state.formData
	// 					// 	? location.state.formData.data.passport
	// 					// 	: '',
	// 					// PassportExpiry: '2023-12-06T00:00:00',
	// 					AddressLine1: location.state.formData
	// 						? location.state.formData.address
	// 						: '',
	// 					AddressLine2: '',
	// 					Fare: {
	// 						Currency: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Currency
	// 							: '',
	// 						BaseFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						Tax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Tax
	// 							: '',
	// 						YQTax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.YQTax
	// 							: '',
	// 						AdditionalTxnFeePub: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeePub
	// 							: '',
	// 						AdditionalTxnFeeOfrd: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
	// 							: '',
	// 						OtherCharges: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OtherCharges
	// 							: '',
	// 						Discount: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Discount
	// 							: '',
	// 						PublishedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.PublishedFare
	// 							: '',
	// 						OfferedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						TdsOnCommission: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnCommission
	// 							: '',
	// 						TdsOnPLB: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnPLB
	// 							: '',
	// 						TdsOnIncentive: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnIncentive
	// 							: '',
	// 						ServiceFee: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.ServiceFee
	// 							: '',
	// 					},
	// 					City: 'Dhanbad',
	// 					CountryCode: 'IN',
	// 					CellCountryCode: '+91',
	// 					ContactNo: location.state.formData
	// 						? location.state.formData.phone
	// 						: '',
	// 					Nationality: 'IN',
	// 					Email: location.state.formData ? location.state.formData.email : '',
	// 					IsLeadPax: true,
	// 					FFAirlineCode: null,
	// 					FFNumber: '',
	// 					GSTCompanyAddress: '',
	// 					GSTCompanyContactNumber: '',
	// 					GSTCompanyName: '',
	// 					GSTNumber: '',
	// 					GSTCompanyEmail: '',
	// 				},
	// 				{
	// 					Title: location.state.formData
	// 						? location.state.formData.titleA3
	// 						: '',
	// 					FirstName: location.state.formData
	// 						? location.state.formData.first_nameA3
	// 						: '',
	// 					LastName: location.state.formData
	// 						? location.state.formData.last_nameA3
	// 						: '',
	// 					PaxType: 1,
	// 					DateOfBirth: '1987-12-06T00:00:00',
	// 					Gender: 1,
	// 					// PassportNo: location.state.formData
	// 					// 	? location.state.formData.data.passport
	// 					// 	: '',
	// 					// PassportExpiry: '2023-12-06T00:00:00',
	// 					AddressLine1: location.state.formData
	// 						? location.state.formData.address
	// 						: '',
	// 					AddressLine2: '',
	// 					Fare: {
	// 						Currency: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Currency
	// 							: '',
	// 						BaseFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						Tax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Tax
	// 							: '',
	// 						YQTax: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.YQTax
	// 							: '',
	// 						AdditionalTxnFeePub: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeePub
	// 							: '',
	// 						AdditionalTxnFeeOfrd: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
	// 							: '',
	// 						OtherCharges: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OtherCharges
	// 							: '',
	// 						Discount: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.Discount
	// 							: '',
	// 						PublishedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.PublishedFare
	// 							: '',
	// 						OfferedFare: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.OfferedFare
	// 							: '',
	// 						TdsOnCommission: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnCommission
	// 							: '',
	// 						TdsOnPLB: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnPLB
	// 							: '',
	// 						TdsOnIncentive: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.TdsOnIncentive
	// 							: '',
	// 						ServiceFee: location.state.OneflightData
	// 							? location.state.OneflightData.Fare.ServiceFee
	// 							: '',
	// 					},
	// 					City: 'Dhanbad',
	// 					CountryCode: 'IN',
	// 					CellCountryCode: '+91',
	// 					ContactNo: location.state.formData
	// 						? location.state.formData.phone
	// 						: '',
	// 					Nationality: 'IN',
	// 					Email: location.state.formData ? location.state.formData.email : '',
	// 					IsLeadPax: true,
	// 					FFAirlineCode: null,
	// 					FFNumber: '',
	// 					GSTCompanyAddress: '',
	// 					GSTCompanyContactNumber: '',
	// 					GSTCompanyName: '',
	// 					GSTNumber: '',
	// 					GSTCompanyEmail: '',
	// 				},
	// 			],
	// 			Baggage: [
	// 				{
	// 					AirlineCode: location.state.OneflightData
	// 						? location.state.OneflightData.AirlineCode
	// 						: '',
	// 					FlightNumber: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Airline.FlightNumber;
	// 								})
	// 						: '',
	// 					WayType: location.state.body ? location.state.body.JourneyType : '',
	// 					Code: 'No Baggage',
	// 					Description: 2,
	// 					Weight: 0,
	// 					Currency: 'INR',
	// 					Price: null,
	// 					Origin: location.state.body
	// 						? location.state.body.Segments[0].Origin
	// 						: '',
	// 					Destination: location.state.body
	// 						? location.state.body.Segments[0].Destination
	// 						: '',
	// 				},
	// 			],
	// 			MealDynamic: [
	// 				{
	// 					AirlineCode: location.state.OneflightData
	// 						? location.state.OneflightData.AirlineCode
	// 						: '',
	// 					FlightNumber: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Airline.FlightNumber;
	// 								})
	// 						: '',
	// 					WayType: location.state.body ? location.state.body.JourneyType : '',
	// 					Code: 'No Meal',
	// 					Description: 2,
	// 					AirlineDescription: '',
	// 					Quantity: 1,
	// 					Currency: 'INR',
	// 					Price: 300,
	// 					Origin: location.state.body
	// 						? location.state.body.Segments[0].Origin
	// 						: '',
	// 					Destination: location.state.body
	// 						? location.state.body.Segments[0].Destination
	// 						: '',
	// 				},
	// 			],
	// 			SeatDynamic: [
	// 				{
	// 					AirlineCode: location.state.OneflightData
	// 						? location.state.OneflightData.AirlineCode
	// 						: '',
	// 					FlightNumber: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Airline.FlightNumber;
	// 								})
	// 						: '',
	// 					CraftType: location.state.OneflightData
	// 						? location.state.OneflightData.Segments[0]
	// 								.filter((i, index) => index === 0)
	// 								.map((it) => {
	// 									return it.Craft;
	// 								})
	// 						: '',
	// 					Origin: location.state.body
	// 						? location.state.body.Segments[0].Origin
	// 						: '',
	// 					Destination: location.state.body
	// 						? location.state.body.Segments[0].Destination
	// 						: '',
	// 					AvailablityType: 1,
	// 					Description: 2,
	// 					Code: '2A',
	// 					RowNo: '2',
	// 					SeatNo: 'A',
	// 					SeatType: 1,
	// 					SeatWayType: 2,
	// 					Compartment: 1,
	// 					Deck: 1,
	// 					Currency: 'INR',
	// 					Price: null,
	// 				},
	// 			],
	// 		};
	// 		dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
	// 	}
	// }
};

export default tbobookingnonlcc;
